// extracted by mini-css-extract-plugin
export default {"container":"LFRKo9","topDivider":"Oh0Ztr","listHoveredBorderColor":"jVBq6Q"};